import apiService from "./apiService";

const requestConsultationList = (query) => {
  const {page, type} = query
  return apiService.get(URIS_D("consultationList", page, type))
}

//TODO implement refund action
const requestConsultationRefund = (query) => {
  return apiService.get(URIS_D("refundConsultation", query))
}


export {requestConsultationList, requestConsultationRefund}

const URIS_D = (url, param1, param2) => {
  return {
    consultationList: `/admin/consultation-histories?item_per_page=10&page=${param1}&type=${param2 ?? 'PAID'}`,
  }[url]
}


